module.exports = __webpack_public_path__ + "img/clasica_en.faab6b23.png";